import { Badge, SxProps } from '@mui/material';
import Avatar from 'ui-component/extended/Avatar';
import AvatarStatus from './AvatarStatus';

interface UserAvatarProps {
  userName: string | undefined;
  src: string | undefined;
  status: 'available' | 'do_not_disturb' | 'offline';
  sx?: SxProps;
  onClick?: () => void;
}
export default function UserAvatar({ userName, src, status, onClick, sx = {} }: UserAvatarProps) {
  return (
    <Badge
      overlap="circular"
      badgeContent={<AvatarStatus status={status} />}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      onClick={onClick}
    >
      <Avatar alt={userName} src={src} sx={sx} />
    </Badge>
  );
}
